import { ChangeDetectionStrategy, Component, computed, effect, inject, input, signal, untracked } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PersonelAvatarComponent } from '@/src/service/fikoyt-ui/src/lib/personel-avatar/personel-avatar.component';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';
import { AltKartHesaplamaService } from '@service/fikoyt-ui/src/lib/dinamik-bilesen/alt-kart-hesaplama.service';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

@Component({
  selector: 'personel-kart',
  standalone: true,
  imports: [CommonModule, PersonelAvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--karakter" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div>
      <div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div>
      <div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar">
        <span class="gc-p gc-p--buyuk" style="--d:7s;--x:15%;--y:25%"></span><span class="gc-p" style="--d:11s;--x:75%;--y:35%"></span>
        <span class="gc-p gc-p--kucuk" style="--d:5s;--x:40%;--y:70%"></span><span class="gc-p" style="--d:9s;--x:85%;--y:15%"></span>
        <span class="gc-p gc-p--buyuk" style="--d:13s;--x:30%;--y:85%"></span><span class="gc-p gc-p--kucuk" style="--d:6s;--x:60%;--y:50%"></span>
      </div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">PERSONEL KAYDI</div>
        @if (deger('sicilNo')) { <span class="gc-etiket gc-etiket--ust-sag">{{ deger('sicilNo') }}</span> }
        <div class="pk-avatar-alani">
          <div class="pk-avatar-cerceve">
            <personel-avatar [kullaniciId]="deger('kullaniciId')" [ad]="deger('ad')" [soyad]="deger('soyad')" [boyut]="56" [durumGoster]="true" [bagliUye]="!!deger('kullaniciId')" />
          </div>
        </div>
        <div class="pk-isim-alan">
          <div class="gc-baslik-cizgi"></div>
          <div class="pk-isim gc-baslik-ana">{{ tamAd() }}</div>
          @if (deger('unvan') || deger('gorev')) { <span class="pk-sinif">{{ deger('unvan') || deger('gorev') }}</span> }
        </div>
        @if (deger('departman')) { <div class="pk-dept-badge">{{ deger('departman') }}</div> }
        <div class="gc-stat-bolge">
          <div class="gc-stat-satir" [title]="'Devamsizlik: ' + ist().devamsizlik">
            <div class="gc-stat-ikon gc-stat-ikon--turuncu"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg></div>
            <span class="gc-stat-isim">DEVAMSIZLIK</span>
            <div class="gc-stat-bar"><div class="gc-stat-bar-dolgu gc-stat-bar--turuncu" [style.width.%]="gorunur() ? halkaDevamsizlik() : 0"></div></div>
            <span class="gc-stat-deger gc-stat-deger--turuncu">{{ ist().devamsizlik }}</span>
          </div>
          <div class="gc-stat-satir" [title]="'Performans: ' + ist().performans + '%'">
            <div class="gc-stat-ikon gc-stat-ikon--yesil"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg></div>
            <span class="gc-stat-isim">PERFORMANS</span>
            <div class="gc-stat-bar"><div class="gc-stat-bar-dolgu gc-stat-bar--yesil" [style.width.%]="gorunur() ? halkaPerformans() : 0"></div></div>
            <span class="gc-stat-deger gc-stat-deger--yesil">{{ ist().performans }}%</span>
          </div>
          <div class="gc-stat-satir" [title]="'Kidem: ' + kidemYil() + ' yil'">
            <div class="gc-stat-ikon gc-stat-ikon--cyan"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></div>
            <span class="gc-stat-isim">KIDEM</span>
            <div class="gc-stat-bar"><div class="gc-stat-bar-dolgu gc-stat-bar--cyan" [style.width.%]="gorunur() ? halkaKidem() : 0"></div></div>
            <span class="gc-stat-deger gc-stat-deger--cyan">{{ kidemYil() }}y</span>
          </div>
        </div>
        @if (altOzet()['adres-bilgisi'] || altOzet()['izin-kaydi'] || altOzet()['egitim-kaydi']) {
          <div class="gc-alt-ozet">
            @if (altOzet()['adres-bilgisi']; as a) { <span class="gc-alt-badge">{{ a.toplam }} adres</span> }
            @if (altOzet()['izin-kaydi']; as i) { <span class="gc-alt-badge">{{ i.toplam }} izin</span> }
            @if (altOzet()['egitim-kaydi']; as e) { <span class="gc-alt-badge">{{ e.toplam }} egitim</span> }
          </div>
        }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 65 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #00b4d8; --accent-rgb: 0,180,216; }
    .gc-icerik { align-items: center; }
    .pk-avatar-alani { margin-top: 4px; }
    .pk-avatar-cerceve { width: 64px; height: 64px; border-radius: 50%; display: flex; align-items: center; justify-content: center; background: conic-gradient(from 0deg, rgba(var(--accent-rgb),.3), rgba(var(--accent-rgb),.05), rgba(var(--accent-rgb),.3)); padding: 3px; box-shadow: 0 0 20px rgba(var(--accent-rgb),.15); }
    .pk-isim-alan { display: flex; flex-direction: column; align-items: center; gap: 4px; width: 100%; }
    .pk-isim { font-size: 15px; font-weight: 800; color: var(--py-metin, #e2e8f0); letter-spacing: .04em; text-align: center; transition: text-shadow .4s; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width: 100%; }
    .gc:hover .pk-isim { text-shadow: 0 0 14px rgba(var(--accent-rgb),.5); }
    .pk-sinif { font-size: 9px; font-weight: 600; padding: 2px 10px; border-radius: 2px; background: rgba(var(--accent-rgb),.08); color: var(--accent); border: 1px solid rgba(var(--accent-rgb),.15); letter-spacing: .08em; text-transform: uppercase; }
    .pk-dept-badge { font-size: 9px; color: var(--py-metin-ikincil, #64748b); letter-spacing: .04em; }
  `],
})
export class PersonelKartComponent extends GameCardBase {
  parametreler = input<any>();
  private hesapSvc = inject(AltKartHesaplamaService);
  altOzet = signal<Record<string, any>>({});
  constructor() {
    super();
    effect(() => { const kartId = this.parametreler()?.kart?._id; if (!kartId) return; untracked(() => this.hesapSvc.hesapla(kartId, 'personel').then(s => { this.altOzet.set(s); this.CD.detectChanges(); })); });
  }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  tamAd = computed(() => { const ad = this.deger('ad') || ''; const soyad = this.deger('soyad') || ''; return (ad + ' ' + soyad).trim() || 'Isimsiz'; });
  ist = signal({ devamsizlik: 0, performans: 0 });
  halkaDevamsizlik = computed(() => Math.min(this.ist().devamsizlik, 100));
  halkaPerformans = computed(() => Math.min(this.ist().performans, 100));
  kidemYil = computed(() => { const tarih = this.deger('iseGirisTarihi'); if (!tarih) return 0; const giris = new Date(tarih); if (isNaN(giris.getTime())) return 0; return Math.max(0, Math.floor((Date.now() - giris.getTime()) / (365.25 * 24 * 60 * 60 * 1000))); });
  halkaKidem = computed(() => Math.min(this.kidemYil() * 5, 100));
}
